import moment from 'moment'

export default class AuthResponse {
    constructor (json) {
        this._responseCode = json.responseCode
        this._accessToken = json.accessToken
        this._expires = json.expiresIn
        this._expiresDT = moment().add(this._expires, 'seconds')
    }

    success () {
        return this._responseCode === 'SUCCESS'
    }

    accessToken () {
        return this._accessToken
    }

    isExpired () {
        return this._expiresDT <= moment()
    }

    toStore () {
        return {
            accessToken: this._accessToken,
            expiresIn: this._expires,
            expiresDate: this._expiresDT
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/responses/AuthResponse.js